export default [
  {
    path: "/qspiFacility",
    component: () =>
      import("@/components/page/QSPI/QspiMasterData/QueryFacility"),
    meta: { title: "QSPI Facility清单" },
  },
  {
    path: "/qspiDC",
    component: () => import("@/components/page/QSPI/QspiMasterData/DCLists"),
    meta: { title: "QSPI DC清单" },
  },
  {
    path: "/ddd",
    component: () =>
      import("@/components/page/QSPI/QspiMasterData/IndicatorOwner"),
    meta: { title: "指标Owner" },
  },
];
